import { alpha, Box, createTheme, styled, ThemeProvider } from "@mui/material";
import { DataGrid, gridClasses, GridToolbar } from "@mui/x-data-grid";
import React, { useMemo, useRef, useEffect, useCallback } from "react";
import { restoreScrollX, saveScrollX } from "../utilities/scrollManager";

const GridWithRef = ({
  rows,
  columns,
  page,
  setPage,
  pageSize,
  setPageSize,
  length,
  hidden = [],
  gridWrapperRef,
}) => {
  const ODD_OPACITY = 1;
  const EVEN_OPACITY = 0.4;

  const getMuiTheme = createTheme({
    typography: {
      fontSize: 12,
    },
  });

  const visibleColumns = useMemo(() => {
    return columns.filter((col) => !hidden.includes(col.field));
  }, [columns, hidden]);

  const memoizedRows = useMemo(() => rows, [rows]);

  useEffect(() => {
    setTimeout(() => {
      restoreScrollX(gridWrapperRef);
    }, 50);
  }, [memoizedRows, page, pageSize]);

  const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
      backgroundColor: "rgba(200, 211, 212, 0.26)",
      "&:hover, &.Mui-hovered": {
        backgroundColor: "rgb(219, 238, 240)",
      },
    },
    [`& .${gridClasses.columnHeaders}`]: {
      backgroundColor: "red",
      color: "#fff",
      fontWeight: "bold",
    },
    [`& .${gridClasses.row}`]: {
      backgroundColor: "white",
      "&:hover, &.Mui-hovered": {
        backgroundColor: alpha(theme.palette.grey["100"], EVEN_OPACITY),
      },
    },
  }));

  return (
    <Box
      ref={gridWrapperRef}
      sx={{
        height: "auto",
        width: "100%",
        display: "flex",
        boxShadow: "5px 5px 10px #CCC",
        borderRadius: "15px",
      }}
      onMouseDown={() => saveScrollX(gridWrapperRef)}
    >
      <ThemeProvider theme={getMuiTheme}>
        <StripedDataGrid
          className="allQuestionnaire-grid"
          rows={memoizedRows}
          columns={visibleColumns}
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "red",
              color: "#fff",
              fontWeight: "bold",
            },
          }}
          pageSizeOptions={[5, 10, 20]}
          pagination
          paginationMode="server"
          rowCount={length}
          paginationModel={{ page, pageSize }}
          onPaginationModelChange={(model) => {
            // saveScrollPosition();
            setPage(model.page);
            setPageSize(model.pageSize);
          }}
          slots={{
            toolbar: () => (
              <div className="grid-toolbar-wrapper">
                <GridToolbar />
              </div>
            ),
          }}
          rowHeight={38}
          disableSelectionOnClick
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
          }
        />
      </ThemeProvider>
    </Box>
  );
};

export default GridWithRef;
